var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFunnel({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3271_68736)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.50108 5H18.5011C18.6451 5.05051 18.7756 5.13331 18.8827 5.24206C18.9898 5.35082 19.0706 5.48264 19.1188 5.62742C19.1671 5.77221 19.1816 5.92612 19.1612 6.07737C19.1407 6.22861 19.086 6.37318 19.0011 6.5L14.0011 12V19L10.0011 16V12L5.00108 6.5C4.91617 6.37318 4.86142 6.22861 4.84101 6.07737C4.8206 5.92612 4.83509 5.77221 4.88335 5.62742C4.93161 5.48264 5.01237 5.35082 5.11945 5.24206C5.22652 5.13331 5.35707 5.05051 5.50108 5Z",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3271_68736"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnel);
export default __webpack_public_path__ + "static/media/funnel.733e6cc95a15d86eeeb3ae6c86cd634a.svg";
export { ForwardRef as ReactComponent };